import { AcceptFormNames } from '~src/domains/common/enums/common';
import { InputLocalizationType } from '~src/domains/common/types/forms';
import { createDefaultFormMeta, createFormMetaSlice } from '~src/utils/forms';

export type ReacceptLocalization = {
  [key: string]: InputLocalizationType;
};

const formMetaDefault = createDefaultFormMeta([
  [AcceptFormNames.AUTOPAY, { value: true }],
]);

export const reacceptFormSlice = createFormMetaSlice(
  'reaccept',
  formMetaDefault,
);

export const {
  updateInputValue,
  updateInputHidden,
  updateInputIsValid,
  registerInputLabel,
  registerValidityConfig,
  registerPostProcess,
} = reacceptFormSlice.actions;

export default reacceptFormSlice.reducer;
